import TextField, {
  TextFieldCustomProps,
} from '~/components/atoms/inputs/TextField';
import { withHookForm } from '~/decorators/withHookForm';

const HookFormTextField = withHookForm<TextFieldCustomProps>(TextField);

export default HookFormTextField;
